import { Box, Typography } from "@mui/material";
import { useCallback } from "react";
import { useAuth } from "../hooks";
import { useNavigate } from "react-router-dom";
import { RoutesEnum } from "../router/routes";
import notFoundSvgImg from "../public/notFound.svg";
import CustomButton from "../components/UIElements/CustomButton";
export default function PageNotFound() {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    const backToHome = useCallback(() => {
        if (isAuthenticated()) {
            navigate("/" + RoutesEnum.monespace);
        } else {
            navigate("/" + RoutesEnum.login);
        }
    }, []);

    return (
        <Box
            sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "2.5rem 0",
                "@media (max-width:1024px)": {
                    padding: "0 1.5rem 3.75rem",
                },
            }}
        >
            <img src={notFoundSvgImg} alt="Logo" className="not-found" />
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "1.5rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    color: "#023",
                    marginBottom: "1.875rem",
                    textAlign: "center",
                }}
            >
                Ooopss ! Il semble que la page que vous recherchez n'est plus
                disponible ou a été déplacée.
            </Typography>
            <CustomButton
                onClick={() => {
                    backToHome();
                }}
                label="Revenir à la page d'accueil"
            />
        </Box>
    );
}
